import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UrlService } from '@core/services/url.service';
import { Subject } from 'rxjs';
import { MbIcon, MbButton } from '@am/moebius';

@Component({
  selector: 'am-banner-dollar-transfer',
  templateUrl: './banner-dollar-transfer.component.html',
  styleUrls: ['./banner-dollar-transfer.component.scss'],
  imports: [MbIcon, MbButton],
})
export class BannerDollarTransferComponent implements OnInit, OnDestroy {
  @Input() query: any;
  public unSubscribe$ = new Subject<void>();
  public currencyCode = 'ARS';
  constructor(private urlService: UrlService) {}

  ngOnInit(): void {
    this.currencyCode = this.query.queryParams.currencyCode;
  }

  redirectChangeCurrency() {
    this.urlService.redirectCurrency(this.currencyCode === 'USD' ? 'ARS' : 'USD');
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
